module.exports = __webpack_public_path__ + "img/hero.e530afc6.png";